module.exports = __webpack_public_path__ + "static/saltaire.cbf1ffc9.jpg";